import React from "react";
import { Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import Search from "../../../components/Search";
import { InfiniteScroll } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import { Space, DatePicker } from "antd";
import FileUpload from "./FileUpload";
import FormPayrollPage from "./form-payroll/FormPayrollPage";
import InputFactory from "../../../components/InputFactory";
import Progress from "../../../components/Progress";
import PayrollSetupsPresenter from "./PayrollSetupsPresenter";
import { hasLength, _getSetupsHolder } from "./helper-payroll/HelperFunction";
import { getFieldWhereClause } from "./helper-payroll/payrollFilterHelpers";
import ModalContentFormPage from "./modal-content/ModalContentFormPage";
class PayrollSetupsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PayrollSetupsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      selected: [],
      lateUndertimeMins: {},
      limit: 50,
      current: 1,
      count: 0,
      personelAirportCount: {},
      panelState: {
        isModalContent: false,
        isFloatingForm: false,
      },
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();

    const [
      natureOfFunctions,
    ] = await Promise.all([
      findObjectUseCase().execute("nature_functions", {
        where: {
          id: "0c8ff78c-352b-42ae-8bc2-aecf8f740c66",
        },
        include: ["payCode"],
        keys: ["payCode"],
      }),
    ]);

    try {
      this.setState((prevState) => ({
        panelState: {
          ...prevState.panelState,
          natureOfFunction: natureOfFunctions[0]?.payCode.amount,
        },
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  getCollectionName() {
    return "employees";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  shouldBeDisabled = (conditions) => {
    if (!conditions) return false;

    return Object.entries(conditions).some(
      ([conditionField, expected]) => {
        const actualValue = hasLength(this.state.panelState?.[conditionField]?.value);

        if (expected === true) return actualValue;
        if (expected === false) return !actualValue;
        return actualValue === expected;
      }
    );
  };

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current, selected, panelState } = this.state;

    // console.log("count", count);

    console.log("OBJECTS", objects);
    console.log("panelState", panelState);

    const { RangePicker } = DatePicker;

    if (!schema) return <Progress />;
    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "agency" &&
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname"
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Generate Payroll
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                 <div className="row p-1">
                  {Object.keys(schema.filters || {})
                    .filter((field) => !["earnings", "sex", "civil", "month", "year", "lengthOfService", "employmentType"].includes(field))
                    .map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div className="col-lg-4 p-1" key={field}>
                          <InputFactory
                            key={field}
                            type={type}
                            field={field}
                            where={{}}
                            onChange={(value, changedField) =>
                              this.presenter.onChangeFilter(type, value, changedField)
                            }
                            {...options}
                          />
                        </div>
                      );
                    })}
                </div>
              </CardView>

              <div style={{ marginTop: "10px", width: "100%" }}>
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center mb-2">
                    <h4 className="text-primary">Employees</h4>
                  </div>

                  <div className="row">
                    {["payrollTypes", "employmentType", "payItems"]
                        .filter((field) => {
                          return schema.fields?.[field];
                        })
                      .map((field) => {
                        let { type, where: existingWhere, disabledIf, emptyFields, keys,  ...options } = schema.fields[field];

                        const fieldState = panelState?.[field];
                        const payrollTypeName = panelState?.payrollTypes?.value?.name;
                        const employmentTypeName = panelState?.employmentType?.value?.name;
                        
                        const mergedWhere = getFieldWhereClause(
                          field,
                          existingWhere,
                          panelState
                        );

                        return (
                          <div className="col-md-4 mt-1" key={field}>
                            <InputFactory
                              key={`${field}-${fieldState?.value?.name}-${payrollTypeName}-${employmentTypeName}`}
                              type={type}
                              field={field}
                              where={mergedWhere}
                              keys={keys}
                              defaultValue={fieldState?.value}
                              onChange={(value) => this.presenter.handleSelectChange(field, value, emptyFields)}
                              disabled={this.shouldBeDisabled(disabledIf)}
                              {...options}
                            />
                          </div>
                        );
                      })}
                  </div>
                  <hr></hr>

                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex flex-wrap"
                      style={{ marginLeft: "auto", gap: "17.5px" }}
                    >
                      {(!panelState?.setups || panelState?.setups?.showDateRange) && (
                        <div className="">
                          <Space direction="vertical" size={20}>
                            <RangePicker
                              style={{ width: "230px" }}
                              onChange={(date) =>
                                this.presenter.onChangeDate(date, objects)
                              }
                              className="custom-range-picker border p-2 fw-semibold"
                            />
                          </Space>
                        </div>
                      )}

                      <FileUpload
                        onFileUpload={(file) => this.presenter.onFileUpload(file)}
                      />
                      <Button
                        onClick={() => this.presenter.onToggleModal("open")}
                      >
                        <i className="bi bi-arrow-clockwise" /> Generate
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                refetch={this.refetchData.bind(this)}
                loadPagination={this.onClickPagination.bind(this)}
                {...(panelState.setups?.isSelected ? { selectable: true } : {})}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
                selected={selected}
                onSelect={(value) => this.presenter.onSelect(value)}
                onSelectAll={this.onSelectAll.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {panelState.isFloatingForm && (
          <FormPayrollPage
            objects={selected.length > 0 ? selected : objects}
            closeFloating={() => this.presenter.onToggleModal("close")}
            refetchData={this.refetchData.bind(this)}
            otherInfo={{
              lateUndertimeMins: this.state.lateUndertimeMins,
              numberOfDutiesinAP: this.state.personelAirportCount
            }}
            panelState={{...panelState}}
          />
        )}
        {panelState.isModalContent && (
          <ModalContentFormPage
            onClose={() => this.presenter.onToggleModal()}
            onGenerate={(object) => this.presenter.onToggleModal("generate", object)}
            panelState={{...panelState}}
            objects={objects}
          />
        )}
      </>
    );
  }
}

export default PayrollSetupsPage;
